<div class="main-wrapper">
  <div class="container">
    <div class="heading">{{section?.header}}</div>
    <div class="divider"></div>
    <div class="tab-sections row">
      <button mat-raised-button *ngFor="let cause of section?.data_images; let i=index" [class]="'mat-raised-button tabs order-'+i" [ngClass]="{'selected': cause?.selected}" (click)="toggle(cause, i)">
        <div [hidden]="cause?.selected" [class]="cause.icon"></div>
        <div [hidden]="cause?.selected" class="title">{{cause.text}}</div>
        <div [hidden]="cause?.selected" class="link">{{cause.link}}</div>
        <div [hidden]="!cause?.selected" class="title">{{cause.invertText}}</div>
      </button>
      <div class="content d-none d-lg-block d-md-block order-6" *ngIf="textDesc">
        <div class="row">
          <div class="col-lg-9 col-md-9 col-12">
              {{textDesc}}
          </div>
          <div class="col-lg-3 col-md-3 col-12">
              <app-sac-button label="Start a Fundraiser" height="35px" width="267px" class="sac-btn" [redirectSac]="true"></app-sac-button>
          </div>
        </div>
      </div>
      <div class="content d-lg-none d-md-none d-sm-none" [ngClass]="buttonIndex > 2 ? 'order-6' : 'order-2'" *ngIf="textDesc">
        {{textDesc}}
        <app-sac-button label="Start a Fundraiser" height="35px" width="267px" class="sac-btn" [redirectSac]="true"></app-sac-button>
      </div>
    </div>
    <div class="need-help-wrapper">
      <app-need-help></app-need-help>
    </div>
  </div>
</div>

<app-sac-button id="leadForm" hidden="true" [openLead]="true"></app-sac-button>
